import * as React from 'react';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { StyledCheckboxFormControlLabel } from '../CheckBoxStyling';
import Message from '../Message';
import { Checkbox } from '@material-ui/core';

type Props = FieldRenderProps<string, HTMLElement> & {
  label?: string;
};

const CheckboxAdapter: FC<Props> = ({
  input: { checked, name, onChange, ...restInput },
  meta,
  label,
  disabled,
  ...rest
}) => {
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched;

  return (
    <>
      <StyledCheckboxFormControlLabel
        control={
          <Checkbox
            {...rest}
            disabled={disabled}
            name={name}
            inputProps={restInput}
            onChange={onChange}
            checked={checked}
            color="primary"
          />
        }
        label={label}
      />
      {showError ? <Message type="error">{meta.error || meta.submitError}</Message> : null}
    </>
  );
};

export default CheckboxAdapter;
